import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var BellIcon = function BellIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "BellIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M7.57 2.903a.608.608 0 0 1 1.038.43c0 .28.162.536.415.656a3.94 3.94 0 0 1 2.252 3.362v1.982q0 .045.005.087c.05.417.178.82.374 1.188H4.346c.196-.368.323-.77.374-1.188a1 1 0 0 0 .005-.087V7.351a3.94 3.94 0 0 1 2.238-3.356.72.72 0 0 0 .429-.672.6.6 0 0 1 .178-.42M6.545 1.878a2.06 2.06 0 0 0-.55.988 5.39 5.39 0 0 0-2.72 4.467v1.953a1.94 1.94 0 0 1-.966 1.417.725.725 0 0 0 .358 1.355h2.609a2.725 2.725 0 0 0 5.448 0h2.61a.725.725 0 0 0 .357-1.355 1.94 1.94 0 0 1-.966-1.417V7.3a5.39 5.39 0 0 0-2.72-4.433 2.058 2.058 0 0 0-3.46-.988m2.729 10.18H6.726a1.275 1.275 0 0 0 2.548 0",
      clipRule: "evenodd"
    })
  }));
};

export { BellIcon };
